interface ITabs {
    activeTab: string,
    handleTabClick: (activeTab: string) => void
}

export const Tabs = ({activeTab, handleTabClick}: ITabs) => {
    return (
        <div className="test-tabs-box">
            <div className="test-tabs-nav">
             <span
                className={`tab-nav-item ${activeTab === 'textType' ? 'active' : ''}`}
                onClick={() => handleTabClick('textType')}>
                Текстовый
             </span>
                <span
                    className={`tab-nav-item ${activeTab === 'audioType' ? 'active' : ''}`}
                    onClick={() => handleTabClick('audioType')}>
                    Аудирование
                </span>
                <span
                    className={`tab-nav-item ${activeTab === 'imageType' ? 'active' : ''}`}
                    onClick={() => handleTabClick('imageType')}>
                    С картинкой
                </span>
            </div>
        </div>
    );
};
